import {useQuery} from '@tanstack/react-query';
import {keywordApi} from '@/contexts/api-context';

export const usePopularKeywordsQuery = () => {
  const query = useQuery({
    queryKey: ['popularKeywords'],
    async queryFn() {
      const response = await keywordApi.getPopularKeywords();
      return response.data;
    },
  });

  return query;
};
